import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { PublicService } from '@site-shared/public';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AcceptActionResolver implements Resolve<string> {
	constructor(private readonly _publicService: PublicService) {}

	public resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<string> {
		this._publicService.segment = route.data['segment'];
		return this._publicService.acceptAction$.pipe(take(1));
	}
}
